import {actions} from "./Reducer"

export const getArtisansReportsAction = (body) => ({
    type : actions.REPORTS_GET_ARTISANS,
    payload : body
})

export const getArtisansReportsSuccessAction = (artisans) => ({
    type : actions.REPORTS_GET_ARTISANS_SUCCESS,
    payload : artisans
})

export const setArtisansReportsIsLoadingAction = (isLoading) => ({
    type: actions.REPORTS_ARTISANS_IS_LOADING,
    payload : isLoading
})

export const setArtisansReportsCountAction = (count) => ({
    type : actions.REPORTS_ARTISANS_COUNT,
    payload : count
})